import React from 'react'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

function PrivateDataMessage({ name }) {
  const { t } = useTranslation()

  return <p className={styles.message}>{t('my_profile.info_block.privateDataMessage', { username: name })}</p>
}

export default PrivateDataMessage
